/**
 * Prefixed copy of a nested path map: { RESOURCE: { KEY: "/path" } }
 * → { RESOURCE: { KEY: `${baseUrl}/path` } }
 */
export const buildFullUrls = (paths, baseUrl) => {
  const full = {};
  Object.keys(paths).forEach((resourceKey) => {
    full[resourceKey] = {};
    Object.keys(paths[resourceKey]).forEach((routeKey) => {
      full[resourceKey][routeKey] = `${baseUrl}${paths[resourceKey][routeKey]}`;
    });
  });
  return full;
};
